import styled from 'styled-components';
import Transition from 'react-transition-group/Transition';
import { MinusIcon } from '@ui/svgs/MinusIcon';
import { PlusIcon } from '@ui/svgs/PlusIcon';
import globalTheme from '../../../theme';
import { DATA_TRACK_TYPE_INTERNAL, DOM_ACCORDION } from '../../../../lib/constants';

const accordianMaxHeight = 100000;

const HelpQuestionContainer = styled.a`
  display: block;
  border: 1px solid ${({ theme }) => theme.c.border.primary};
  border-radius: ${({ theme }) => theme.radius.md};
  text-decoration: none;

  ${({ theme }) => theme['elevation-shadow']['1']}

  &:focus {
    border-color: ${({ theme }) => theme.c.border.focus};
    box-shadow: inset 0 0 0 1px ${({ theme }) => theme.c.border.focus} !important;
  }
`;

const HelpQuestionContentDiv = styled.div`
  display: flex;
`;

const HelpQuestionDiv = styled.div`
  ${({ theme }) => theme.typographyRebrand.body.md}
  color: ${({ theme }) => theme.c.text.primary};
  ${({ $isExpanded }) => $isExpanded && `
    font-weight: var(--typography-font-weight-bold);
  `}
  padding: ${(p) => p.theme.unit(3)} ${({ theme }) => theme.unit(2)};
  flex-grow: 1;
  cursor: pointer;

  display: flex;
  gap: ${({ theme }) => theme.unit(3)};
  justify-content: space-between;

  &:hover {
    color: ${({ theme }) => theme.c.text.interactive};
    font-weight: var(--typography-font-weight-bold);
  }
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  color: ${({ theme }) => theme.c.icon.interactive};
`;

const HelpQuestionResponseDiv = styled.div`
  ${({ theme }) => theme.typographyRebrand.body.sm}
  color: ${(p) => p.theme.c.text.primary};
  padding: 0 ${({ theme }) => theme.unit(2)} ${({ theme }) => theme.unit(3)};


  strong {
    font-weight: var(--typography-font-weight-bold);
  }

  a {
    color: ${(p) => p.theme.c.text.interactive};
    text-decoration: underline;
    :hover {
      color: ${(p) => p.theme.c.text['interactive-hover']};
    }
  }
`;

const defaultStyle = {
  transition: `max-height ${globalTheme.transitionDurationCssValue} ease, opacity ${globalTheme.transitionDurationCssValue}`,
  opacity: 0,
  maxHeight: 0,
};

const transitionStyles = {
  entering: { opacity: 1, maxHeight: accordianMaxHeight },
  entered: { opacity: 1, maxHeight: accordianMaxHeight },
  exiting: { opacity: 0, maxHeight: 0, overflow: 'hidden' },
  exited: { opacity: 0, maxHeight: 0, overflow: 'hidden' },
};

const HelpQuestion = (props) => {
  const {
    helpQuestionData = {},
    isLast = false,
    sectionSlug = '',
    isMobile = false,
    onQuestionSelect,
    selectedQuestions,
  } = props;

  const {
    slug = '',
    question = '',
    answer = '',
  } = helpQuestionData;

  const isExpanded = selectedQuestions[slug];
  const IconToUse = isExpanded ? MinusIcon : PlusIcon;

  const helpQuestionResponse = (
    <HelpQuestionResponseDiv
      onKeyPress={(e) => { e.stopPropagation(); }}
      dangerouslySetInnerHTML={{
        __html: answer,
      }} />
  );

  const duration = globalTheme.transitionDuration;
  const id = `${sectionSlug}-_-${slug}`;

  return (
    <HelpQuestionContainer
      tabIndex="0"
      href={`#${id}`}
      data-track-type={DATA_TRACK_TYPE_INTERNAL}
      data-track-id={slug}
      data-track-click={`${DOM_ACCORDION}:${sectionSlug}`}
      onKeyPress={onQuestionSelect.bind(this, sectionSlug, slug)}
      isLast={isLast}
    >
      <HelpQuestionContentDiv>
        <HelpQuestionDiv
          $isExpanded={isExpanded}
          onClick={onQuestionSelect.bind(this, sectionSlug, slug)}
        >
          <span>{question}</span>
          <IconContainer>
            <IconToUse />
          </IconContainer>
        </HelpQuestionDiv>
      </HelpQuestionContentDiv>
      <Transition in={isExpanded} timeout={duration}>
        {(state) => (
          <div style={{
            ...defaultStyle,
            ...transitionStyles[state],
          }}>
            {isExpanded && helpQuestionResponse}
          </div>
        )}
      </Transition>
    </HelpQuestionContainer>
  );
};

export default HelpQuestion;
